import { useEffect, useState } from "react";
import tw from "twin.macro";
import { useLocation, useNavigate } from "react-router-dom";
import Noimg from "../images/no_img.jpg";
import { joinScheme, dayClose } from "../api/NewSchemeApi";
import { getBranchId, getCustomerId, getCustomerName } from "../utility/HeaderConfig";
import moment from "moment";
import { motion } from "framer-motion";
import { branchdetails } from "api/BranchDetailsApi";
import { getAllDomainEmployeeDetails } from "api/EmployeeApi";
import toast, { Toaster } from "react-hot-toast";

// eslint-disable-next-line
const Heading = tw.h1`text-center`;

const INPUT_STYLE = {
  width: "100%", padding: "12px 14px", border: "1.5px solid #f5edda",
  borderRadius: 10, fontSize: 14, color: "#524017", background: "#faf7ff",
  outline: "none", transition: "border-color .14s",
  fontFamily: "inherit",
};

const LABEL_STYLE = {
  display: "block", fontSize: 12, fontWeight: 700, color: "#6c6c70",
  textTransform: "uppercase", letterSpacing: ".08em", marginBottom: 6,
};

export default ({ configImages }) => {
  const [Employee, setEmployee] = useState("");
  const [DayClose, setDayClose] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [BranchMobile, setBranchMobile] = useState("");
  const [Modal, setModal] = useState([]);

  const location = useLocation();
  const schemeDetails = location.state !== undefined ? location.state : "";
  let statusName = schemeDetails[1]?.type?.toLowerCase() === "digigold" ? "Active" : "Waiting_For_Approval";
  const [Installment, setInstallment] = useState(schemeDetails.chitAmount ? schemeDetails.chitAmount : 0);
  const history = useNavigate();

  useEffect(() => {
    dayCloseDay();
    employees();
    getbranchdetails();
    // eslint-disable-next-line
  }, []);

  const dayCloseDay = () => {
    dayClose({ module: "savings_scheme", branchId: getBranchId() }).then((data) => {
      setDayClose(moment(data.response[0].activeDate).format("YYYY-MM-DD"));
    });
  };

  const employees = () => {
    getAllDomainEmployeeDetails({ name: "ONLINEPAYMENT" }).then((data) => setEmployee(data.response[0].id));
  };

  const getbranchdetails = () => {
    branchdetails(getBranchId()).then((data) => setBranchMobile(data.response.mobile));
  };

  const close = () => history("/MyScheme");

  let endDate = moment(DayClose).add(parseFloat(schemeDetails.noOfMonths - 1), "M").format("DD-MM-YYYY");

  const joinData = () => {
    let endDateFormatted = moment(DayClose).add(parseFloat(schemeDetails.noOfMonths - 1), "M").format("YYYY-MM-DD");
    const filters = {
      metaChit: { id: schemeDetails.item.id },
      branchId: getBranchId(),
      collectionType: "online",
      employeeId: Employee,
      customerId: { id: getCustomerId() },
      enrollmentDate: DayClose,
      scheduleCompletionDate: endDateFormatted,
      customerCredibility: "Neutral",
      status: statusName,
      chitAmount: Installment,
      enrollmentMode: "WEB",
      chitEnrollmentType: "NEW",
    };
    const responseData = joinScheme(JSON.stringify(filters));
    responseData.then(
      (data) => {
        setModal(data.response.chitId);
        setshowModal(true);
        toast.success("Saving scheme saved successfully!", { duration: 3000, position: "top-right" });
      },
      (err) => console.log(err)
    );
  };

  const imgSrc = schemeDetails.chitImage && schemeDetails.chitImage !== "" && schemeDetails.chitImage !== "-" && schemeDetails.chitImage !== "Image_Not_Available"
    ? schemeDetails.chitImage : Noimg;

  return (
    <>
      <Toaster position="top-right" />

      <section style={{ padding: "48px 0 72px", background: "linear-gradient(160deg,#faf7ff 0%,#fdf8eb 100%)", minHeight: "70vh" }}>
        <div className="container">
          {/* Page title */}
          <div style={{ textAlign: "center", marginBottom: 40 }}>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".16em", textTransform: "uppercase", color: "#9c7a3a", margin: "0 0 8px" }}>
              Enrollment
            </p>
            <h1 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: "clamp(28px,4vw,40px)", fontWeight: 600, color: "#524017", margin: 0 }}>
              Join Scheme
            </h1>
          </div>

          <div className="row align-items-start justify-content-center g-4">
            {/* Scheme summary card */}
            <div className="col-md-12 col-lg-5 col-xl-4">
              <div style={{ borderRadius: 20, overflow: "hidden", boxShadow: "0 8px 40px rgba(79,50,103,.14)", background: "#fff" }}>
                <div style={{ overflow: "hidden" }}>
                  <img src={imgSrc} alt="schemeImage" style={{ width: "100%", height: 240, objectFit: "cover", display: "block" }} />
                </div>
                <div style={{ padding: "0" }}>
                  <div style={{ padding: "16px 20px 8px", textAlign: "center", borderBottom: "1px solid #f0e9fa" }}>
                    <h3 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: 22, fontWeight: 700, color: "#524017", margin: 0, textTransform: "uppercase" }}>
                      {schemeDetails.chitTypeName}
                    </h3>
                  </div>
                  {[
                    { label: "Duration", value: schemeDetails.noOfMonths ? `${schemeDetails.noOfMonths} Months` : "—" },
                    { label: "Total Payable", value: schemeDetails.maturityAmount ? `₹ ${schemeDetails.maturityAmount}` : "—" },
                    { label: "Installment", value: schemeDetails.chitAmount ? `₹ ${schemeDetails.chitAmount}` : "—" },
                    { label: "Maturity Date", value: endDate || "—" },
                  ].map((row, i, arr) => (
                    <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 20px", borderBottom: i < arr.length - 1 ? "1px solid #f5f0ff" : "none" }}>
                      <span style={{ fontSize: 12.5, color: "#6c6c70", fontWeight: 500 }}>{row.label}</span>
                      <span style={{ fontSize: 13.5, color: "#524017", fontWeight: 700 }}>{row.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Enrollment form */}
            <div className="col-md-12 col-lg-7 col-xl-6">
              <div style={{ background: "#fff", borderRadius: 20, boxShadow: "0 8px 40px rgba(79,50,103,.12)", padding: "36px 36px 40px" }}>
                <h4 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: 26, fontWeight: 700, color: "#524017", marginBottom: 4, textAlign: "center" }}>
                  Enrollment Details
                </h4>
                <div style={{ width: 40, height: 3, background: "linear-gradient(90deg,#9c7a3a,#d4af5a)", borderRadius: 999, margin: "0 auto 28px" }} />

                <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                  {/* Name */}
                  <div>
                    <label style={LABEL_STYLE}>Full Name</label>
                    <input type="text" style={{ ...INPUT_STYLE, cursor: "not-allowed", opacity: .7 }} value={getCustomerName()} disabled />
                  </div>

                  {/* Installment */}
                  <div>
                    <label style={LABEL_STYLE}>Monthly Installment (₹)</label>
                    <input
                      type="text"
                      style={{
                        ...INPUT_STYLE,
                        cursor: schemeDetails.chitPaymentType && (schemeDetails.chitPaymentType === "FLEXIBLE" || schemeDetails.chitPaymentType === "FLEXIBLE_ENROLLMENT") ? "text" : "not-allowed",
                        opacity: schemeDetails.chitPaymentType && (schemeDetails.chitPaymentType === "FLEXIBLE" || schemeDetails.chitPaymentType === "FLEXIBLE_ENROLLMENT") ? 1 : .7,
                      }}
                      value={Installment}
                      onChange={(e) => setInstallment(e.target.value)}
                      disabled={!(schemeDetails.chitPaymentType && (schemeDetails.chitPaymentType === "FLEXIBLE" || schemeDetails.chitPaymentType === "FLEXIBLE_ENROLLMENT"))}
                      onFocus={(e) => e.target.style.borderColor = "#9c7a3a"}
                      onBlur={(e) => e.target.style.borderColor = "#f5edda"}
                    />
                  </div>

                  {/* Start Date */}
                  <div>
                    <label style={LABEL_STYLE}>Start Date</label>
                    <input type="text" style={{ ...INPUT_STYLE, cursor: "not-allowed", opacity: .7 }} value={DayClose} disabled />
                  </div>

                  {/* Submit */}
                  <button
                    onClick={joinData}
                    style={{
                      marginTop: 8, padding: "14px 20px", width: "100%",
                      background: "linear-gradient(135deg,#6b5330,#9c7a3a)",
                      color: "#fff", fontWeight: 700, fontSize: 14, letterSpacing: ".07em",
                      textTransform: "uppercase", border: "none", borderRadius: 12,
                      cursor: "pointer", boxShadow: "0 6px 20px rgba(79,50,103,.3)",
                      transition: "opacity .14s, transform .14s", display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.opacity = ".88"; e.currentTarget.style.transform = "translateY(-2px)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = "none"; }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                    Confirm & Join Scheme
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Success modal */}
      {showModal && (
        <>
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            style={{ position: "fixed", inset: 0, zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
          >
            <div style={{ background: "#fff", borderRadius: 24, boxShadow: "0 24px 80px rgba(0,0,0,.2)", width: "100%", maxWidth: 420, overflow: "hidden" }}>
              {/* Header */}
              <div style={{ background: "linear-gradient(135deg,#6b5330,#9c7a3a)", padding: "20px 24px", textAlign: "center" }}>
                <div style={{ width: 52, height: 52, borderRadius: "50%", background: "rgba(255,255,255,.2)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px" }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <h5 style={{ color: "#fff", margin: 0, fontSize: 18, fontWeight: 700 }}>Successfully Enrolled!</h5>
              </div>
              {/* Body */}
              <div style={{ padding: "24px 24px 8px", textAlign: "center" }}>
                <p style={{ fontSize: 13, color: "#6c6c70", marginBottom: 6 }}>Your Chit ID</p>
                <p style={{ fontSize: 22, fontWeight: 800, color: "#524017", marginBottom: 16, fontFamily: "Cormorant Garamond,Georgia,serif" }}>{Modal}</p>
                <div style={{ background: "#faf5ff", borderRadius: 12, padding: "14px 16px", marginBottom: 8 }}>
                  <p style={{ fontSize: 13, color: "#48484a", margin: "0 0 4px" }}>Contact customer support to activate</p>
                  <strong style={{ fontSize: 15, color: "#6b5330" }}>{BranchMobile}</strong>
                  <p style={{ fontSize: 12, color: "#6c6c70", margin: "8px 0 0" }}>Wed – Tue &nbsp;·&nbsp; 9:00 AM – 8:00 PM</p>
                </div>
              </div>
              <div style={{ padding: "8px 24px 24px" }}>
                <button onClick={close}
                  style={{ width: "100%", padding: "13px", background: "#6b5330", color: "#fff", border: "none", borderRadius: 12, fontWeight: 700, fontSize: 14, cursor: "pointer", letterSpacing: ".05em" }}>
                  View My Schemes
                </button>
              </div>
            </div>
          </motion.div>
          <div style={{ opacity: 0.4, position: "fixed", inset: 0, zIndex: 40, background: "#000" }}></div>
        </>
      )}
    </>
  );
};